import React from 'react';

export const EventBody = ({ children }: { children: React.ReactNode }) => {
    return (
        <div
            className="event-listing__body l-sm-pad-top-0"
            data-testid="non-event-details"
        >
            {children}
        </div>
    );
};
